<template>
    <div class="left_panel design_studio_panel">
        <div class="default_content_show">
            <div class="desc_design_studio">
                <p>
                    Select a template or create your own design by adding text,
                    selecting a clipart or uploading your own artwork
                </p>
            </div>
            <div class="default_inner_content">
                <h4 class="heading5">Add quantities to see pricing</h4>
                <p class="item-color">
                    <span class="color_port">
                        <span class="span_add_item mr_8">Item:</span>
                        <router-link
                            v-if="!t_shirt_24_hour"
                            target="_blank"
                            :to="{
                                name: 'product_details',
                                params: { id_of_product: product_id }
                            }"
                        >
                            {{ product_title }}
                        </router-link>
                        <router-link
                            v-else
                            target="_blank"
                            :to="{
                                name: '24hoursTShirts',
                                params: { id_of_product: product_id }
                            }"
                        >
                            {{ product_title }}
                        </router-link>
                    </span>
                </p>
                <p class="item-color">
                    <span class="color_port">
                        <span class="span_add_item mr_8">SKU:</span>
                        {{ product_number }}
                    </span>
                </p>
                <div
                    class="design_panel_block"
                    v-for="(design_area, index) in designAreaData"
                    :key="index"
                >
                    <h4 class="panel_heading">{{ design_area.label }}:</h4>
                    <div class="panel_block">
                        <span class="panel_inner">Imprint Width:</span>
                        <span class="panel_inner">
                            {{ design_area.widthIn }} "</span
                        >
                    </div>
                    <div class="panel_block">
                        <span>Imprint Height:</span>
                        <span> {{ design_area.heightIn }} "</span>
                    </div>
                </div>
                <small v-if="t_shirt_24_hour">24 Hours T-Shirt</small>
                <div v-if="false">
                    <section class="product_detail_tabs qty_main_section">
                        <div class="container">
                            <div class="row">
                                <ul
                                    class="nav nav-tabs default_tabs qty_tab_default"
                                    id="product_tabs"
                                    role="tablist"
                                >
                                    <li
                                        v-for="(gender, key, index) in genders"
                                        :key="index"
                                        class="nav-item"
                                        role="presentation"
                                    >
                                        <a
                                            class="nav-link"
                                            :class="key == 0 ? 'active' : ''"
                                            :id="gender"
                                            data-toggle="tab"
                                            :href="'#tav-id-' + key"
                                            role="tab"
                                            @click="
                                                setActiveGender(gender, key)
                                            "
                                            :aria-controls="gender"
                                            :aria-selected="
                                                key == 0 ? 'true' : 'false'
                                            "
                                        >
                                            {{ gender }}
                                        </a>
                                    </li>
                                </ul>
                                <div class="qty_cont_01" id="myTabContent">
                                    <div class="tab-pane fade show active">
                                        <ul class="clr_qty_youth">
                                            <li>
                                                <span class="color_inner"
                                                    >Color
                                                </span>
                                                <img
                                                    v-if="
                                                        user_selected_values[
                                                            activeColorIndex
                                                        ].swatches
                                                    "
                                                    v-tooltip="
                                                        user_selected_values[
                                                            activeColorIndex
                                                        ].color
                                                    "
                                                    :src="
                                                        user_selected_values[
                                                            activeColorIndex
                                                        ].swatches
                                                    "
                                                    class="color_picker_inner"
                                                />
                                                <span
                                                    v-else
                                                    v-tooltip="
                                                        user_selected_values[
                                                            activeColorIndex
                                                        ].color
                                                    "
                                                    class="color_picker_inner"
                                                    :style="
                                                        'background-color:' +
                                                        user_selected_values[
                                                            activeColorIndex
                                                        ].color_hash
                                                    "
                                                ></span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                    <div
                        class="best_price"
                        v-if="user_selected_values[activeColorIndex]"
                    >
                        <table>
                            <tr
                                class="screen_810_bdr"
                                v-for="(
                                    sizes, ky, indxx
                                ) in user_selected_values[activeColorIndex]
                                    .unique_sizes"
                                :key="indxx"
                            >
                                <template v-if="sizes.quantity > 0">
                                    <th class="base_cost">
                                        <b
                                            >BASE COST (Apparel plus One
                                            Decoration Color/Location)</b
                                        >
                                    </th>
                                    <th class="base_cost text_right">
                                        <b>{{ sizes.Size.size }}</b>
                                    </th>
                                    <th class="price_multi">
                                        <strong>
                                            {{ sizes.quantity }}
                                            <b>&#215;</b>
                                            {{ icPriceFormat(sizes.cost) }}
                                        </strong>
                                    </th>
                                    <th class="base_price text_right">
                                        {{ icPriceFormat(sizes.total_cost) }}
                                    </th>
                                </template>
                            </tr>

                            <br />
                            <tr
                                class="screen_810_bdr"
                                v-if="
                                    user_selected_values[activeColorIndex]
                                        .non_standard_fees
                                "
                            >
                                <td class="total_default">
                                    <strong>Non standard fees</strong>
                                </td>
                                <td></td>
                                <td></td>
                                <!-- <td></td> -->
                                <td class="price_default">
                                    <strong>
                                        {{
                                            icPriceFormat(
                                                user_selected_values[
                                                    activeColorIndex
                                                ].non_standard_fees
                                            )
                                        }}
                                    </strong>
                                </td>
                            </tr>

                            <tr
                                class="screen_810_bdr"
                                v-if="
                                    user_selected_values[activeColorIndex]
                                        .name_number_fees
                                "
                            >
                                <td class="total_default">
                                    <strong>Name & Number fees</strong>
                                </td>
                                <td></td>
                                <td></td>
                                <!-- <td></td> -->
                                <td class="price_default">
                                    <strong>
                                        {{
                                            icPriceFormat(
                                                user_selected_values[
                                                    activeColorIndex
                                                ].name_number_fees
                                            )
                                        }}
                                    </strong>
                                </td>
                            </tr>
                            <tr class="screen_810_bdr">
                                <td class="total_default">
                                    <strong>Total</strong>
                                </td>
                                <td></td>
                                <td></td>
                                <td class="price_default">
                                    <strong>
                                        {{
                                            icPriceFormat(
                                                user_selected_values[
                                                    activeColorIndex
                                                ].total_cost_gender_wise
                                            )
                                        }}
                                    </strong>
                                </td>
                            </tr>

                            <tr class="default_bdr total_coast_design">
                                <td
                                    width="40%"
                                    class="total_cost dtab_total_c text_right"
                                >
                                    Total Cost
                                </td>
                                <td width="40%" class="total_price">
                                    {{
                                        icPriceFormat(
                                            user_selected_values[
                                                activeColorIndex
                                            ].total_cost_gender_wise
                                        )
                                    }}
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    /* eslint-disable */
    name: "Dashboard",
    /* eslint-enable */
    props: [
        "product_title",
        "product_id",
        "genders",
        "user_selected_values",
        "activeColorIndex",
        "t_shirt_24_hour",
        "product_number",
        "designAreaData"
    ],
    data() {
        return {
            isBusy: false
        };
    },
    computed: {},
    components: {},
    mounted() {},
    methods: {}
};
</script>
